/**
* Filter posts by taxonomy - voproperty
*/

( function( $ ) {
	let ajaxLock = false;

	$('#filter-vomunicipality').change(function() {
		console.log('vomunicipality running')
		ajaxFilterPostTypeByTerm( $(this).val(), $(this).data('voproperty'), 'filter_option_result' );
	});

	$('#filter-premises').change(function() {
		console.log('premesis running')
		ajaxFilterPostTypeByTerm( $(this).val(), $(this).data('premises'), 'filter_option_premises_result' );
	});

	const ajaxFilterPostTypeByTerm = (term_id, slug, action) => {
		ajaxLock = true;

		console.log(parseInt(term_id));
		console.log(slug);

		$.ajax({
			method: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json',
			data: {
				action: action,
				term_id: term_id,
				slug: slug,
			}
		})
		.done(function(response) {
			// This will reset the archive
			if ( 0 == parseInt(term_id) ) {
				window.location.reload(true);
				return;
			}

			// Gör logik för voestates eller om det är premises
			if (action == "filter_option_premises_result") {
				console.log("slug", slug);
				if ( 'none' == slug ) {
					
					$('.premises__archive .premises-row').empty();
					$('.premises__archive .premises-row').append(response.content);
				}
				if ( 'none' != slug ) {
					$(`.premises__archive .${slug}`).empty();
					$(`.premises__archive .${slug}`).append(response.content);
				}

			} else if (action == "filter_option_result") {
				if ( 'none' == slug ) {
				
					$('.estate-online__archive .main-archive').empty();
					$('.estate-online__archive .main-archive').append(response.content);
				}
				if ( 'none' != slug ) {
					$(`.estate-online__archive .${slug}`).empty();
					$(`.estate-online__archive .${slug}`).append(response.content);
				}
			}
				

		console.log(slug);

			ajaxLock = false;
			console.log(response);
			console.log( 'Success' );
		})
		.fail(function(jqXHR, textStatus, errorThrown) {
			ajaxLock = false;

			console.log(XMLHttpRequest);
			console.log(textStatus);
			console.log(errorThrown);

			console.log( 'Failed' );
		});
	}

})(jQuery);
